import React from "react";
import { useClientAdjustments } from "@/components/ClientAdjustment/useClientAdjustments";
import { PageHeader } from "@/components/ClientAdjustment/PageHeader";
import { StatsCards } from "@/components/ClientAdjustment/StatsCards";
import { FilterBar } from "@/components/ClientAdjustment/FilterBar";
import { BulkFillBar } from "@/components/ClientAdjustment/BulkFillBar";
import { AdjustmentTable } from "@/components/ClientAdjustment/AdjustmentTable";
import { FloatingActionBar } from "@/components/ClientAdjustment/FloatingActionBar";
import { SaveConfirmationModal } from "@/components/ClientAdjustment/Modals/SaveConfirmationModal";
import { RemoveConfirmationModal } from "@/components/ClientAdjustment/Modals/RemoveConfirmationModal";
import { HistoryModal } from "@/components/ClientAdjustment/Modals/HistoryModal";

export default function ClientAdjustmentPage() {
    const {
        currentYear,
        yearOptions,
        cycleYear,
        setCycleYear,
        isPastYear,
        search,
        setSearch,
        groupFilter,
        setGroupFilter,
        stateFilter,
        setStateFilter,
        groupOptions,
        stateOptions,
        hasActiveFilters,
        handleClearFilters,
        filteredClients,
        savedAdjustments,
        drafts,
        focusedInput,
        setFocusedInput,
        selectedMap,
        selectedCount,
        allSelected,
        handleToggleSelectAll,
        handleToggleSelectRow,
        bulkPercent,
        handleBulkPercentChange,
        handleBulkPercentBlur,
        handleApplyBulkPercent,
        dirtyClients,
        dirtyCount,
        avgAdjustmentStr,
        handleDraftInput,
        handleDraftFocus,
        handleDraftBlur,
        handleDiscardChanges,
        showSave,
        setShowSave,
        saveComment,
        setSaveComment,
        handleOpenSave,
        handleConfirmSave,
        showRemove,
        setShowRemove,
        removeTarget,
        removeComment,
        setRemoveComment,
        handleOpenRemove,
        handleConfirmRemove,
        showHistory,
        setShowHistory,
        historyTarget,
        historyRows,
        isHistoryLoading,
        handleOpenHistory,
        isLoading,
        isSubmitting,
    } = useClientAdjustments();

    return (
        <div style={{ minHeight: "100vh", background: "#f7f8fa", fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif", color: "#1f2933" }}>
            <div style={{ maxWidth: "1440px", margin: "0 auto", padding: "28px 40px 160px" }}>
                {/* Cabeçalho e Seleção de Ciclo */}
                <PageHeader
                    cycleYear={cycleYear}
                    setCycleYear={setCycleYear}
                    yearOptions={yearOptions}
                    isPastYear={isPastYear}
                    currentYear={currentYear}
                />

                {/* Métricas Principais */}
                <StatsCards
                    totalExhibited={filteredClients.length}
                    selectedCount={selectedCount}
                    dirtyCount={dirtyCount}
                    avgAdjustmentStr={avgAdjustmentStr}
                    cycleYear={cycleYear}
                />

                {/* Filtros e Busca */}
                <FilterBar
                    search={search}
                    setSearch={setSearch}
                    groupFilter={groupFilter}
                    setGroupFilter={setGroupFilter}
                    stateFilter={stateFilter}
                    setStateFilter={setStateFilter}
                    groupOptions={groupOptions}
                    stateOptions={stateOptions}
                    hasActiveFilters={hasActiveFilters}
                    handleClearFilters={handleClearFilters}
                />

                {/* Preenchimento em Lote */}
                <BulkFillBar
                    isPastYear={isPastYear}
                    bulkPercent={bulkPercent}
                    handleBulkPercentChange={handleBulkPercentChange}
                    handleBulkPercentBlur={handleBulkPercentBlur}
                    focusedInput={focusedInput}
                    setFocusedInput={setFocusedInput}
                    selectedCount={selectedCount}
                    handleApplyBulkPercent={handleApplyBulkPercent}
                />

                {/* Tabela de Dados dos Clientes */}
                <AdjustmentTable
                    isLoading={isLoading}
                    filteredClients={filteredClients}
                    allSelected={allSelected}
                    handleToggleSelectAll={handleToggleSelectAll}
                    selectedMap={selectedMap}
                    handleToggleSelectRow={handleToggleSelectRow}
                    savedAdjustments={savedAdjustments}
                    drafts={drafts}
                    cycleYear={cycleYear}
                    isPastYear={isPastYear}
                    focusedInput={focusedInput}
                    handleDraftInput={handleDraftInput}
                    handleDraftFocus={handleDraftFocus}
                    handleDraftBlur={handleDraftBlur}
                    handleOpenHistory={handleOpenHistory}
                    handleOpenRemove={handleOpenRemove}
                />
            </div>

            {/* Barra Flutuante de Alterações Pendentes */}
            <FloatingActionBar
                dirtyCount={dirtyCount}
                cycleYear={cycleYear}
                handleDiscardChanges={handleDiscardChanges}
                handleOpenSave={handleOpenSave}
            />

            {/* Modais */}
            <SaveConfirmationModal
                showSave={showSave}
                setShowSave={setShowSave}
                cycleYear={cycleYear}
                dirtyCount={dirtyCount}
                dirtyClients={dirtyClients}
                savedAdjustments={savedAdjustments}
                drafts={drafts}
                saveComment={saveComment}
                setSaveComment={setSaveComment}
                handleConfirmSave={handleConfirmSave}
                isSubmitting={isSubmitting}
            />

            <RemoveConfirmationModal
                showRemove={showRemove}
                setShowRemove={setShowRemove}
                removeTarget={removeTarget}
                cycleYear={cycleYear}
                removeComment={removeComment}
                setRemoveComment={setRemoveComment}
                handleConfirmRemove={handleConfirmRemove}
                isSubmitting={isSubmitting}
            />

            <HistoryModal
                showHistory={showHistory}
                setShowHistory={setShowHistory}
                historyTarget={historyTarget}
                historyRows={historyRows}
                isHistoryLoading={isHistoryLoading}
                cycleYear={cycleYear}
            />
        </div>
    );
}
